import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface BlockquoteProps extends ComponentPropsWithRef<"blockquote"> {
  blockPath: string;
  styles?: Record<string, StyleValue>;
  text: string;
}

export const Blockquote = forwardRef<HTMLQuoteElement, BlockquoteProps>(
  ({ text, blockPath, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <blockquote
        ref={ref}
        className={classNames(
          "wb-text-primary wb-font-medium wb-border-l-2 wb-border-primary wb-py-1 wb-pl-2 wb-italic",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </blockquote>
    );
  },
);

Blockquote.displayName = "Blockquote";
